import { ReactComponent as AddGuestAccessIcon } from "assets/images/iconsV2/user-plus-01.svg";
import testIds from "constants/testIds";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import ActionButton from "../TopNavV2/TopNavActions/ShipperProviderActions/ActionButton";

interface IGuestAccessMenuItemProps {
  openGuestAccessDialog: () => void;
}

function GuestAccessMenuItem({ openGuestAccessDialog }: IGuestAccessMenuItemProps) {
  return (
    <ActionButton
      onClick={() => {
        openGuestAccessDialog();
      }}
      icon={<AddGuestAccessIcon width={16} height={16} />}
      title={<FormattedMessage id="components.molecules.navigation.addGuestAccess" defaultMessage="Add guest access" />}
      testId={testIds.SHIPMENT_DASHBOARD_INVITE_GUEST_BUTTON}
    />
  );
}

GuestAccessMenuItem.propTypes = {
  openGuestAccessDialog: PropTypes.func.isRequired,
};

export default GuestAccessMenuItem;
